import { render, staticRenderFns } from "./DocumentDetailList3.vue?vue&type=template&id=2a0d9db8&scoped=true"
import script from "./DocumentDetailList3.vue?vue&type=script&lang=js"
export * from "./DocumentDetailList3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d9db8",
  null
  
)

export default component.exports